(function ($) {
  'use strict';

  //below checks window size on load and will hide or show expertise accordingly. 
  if (($('li').hasClass('staff-listing__tag-item--expertise') && window.innerWidth <= 600)) {
    $('.staff-listing__tag-item--expertise').addClass('staff-listing__tag-item--hidden');
  }

  if (($('li').hasClass('staff-listing__tag-item--expertise') && window.innerWidth >= 601)) {
    $('.staff-listing__tag-item--expertise').removeClass('staff-listing__tag-item--hidden');
  }

  if (($('li').hasClass('staff-listing__tag-item--research') && window.innerWidth <= 600)) {
    $('.staff-listing__tag-item--research').addClass('staff-listing__tag-item--hidden');
  }

  if (($('li').hasClass('staff-listing__tag-item--research') && window.innerWidth >= 600)) {
    $('.staff-listing__tag-item--research').removeClass('staff-listing__tag-item--hidden');
  }


  var reconfigureStaffListing = function () {
    // if side bar exists, move contact details underneath the staff keywords area
    if (($('.sidebar').length > 0) || window.innerWidth <= 600) {
      $('.staff-listing__item')
        .each(function () {
          //move contact details to taglist
          $(this)
            .find('.staff-listing__contact')
            .appendTo($(this).find('.staff-listing__tags'))
            .wrap('<li class="staff-listing__tag-item"></li>')
            .css('marginTop', '0.25rem');
          //make staff details fullwidth
          $(this)
            .find('.staff-listing__details')
            .css('width', '100%')
            .css('marginRight', 0);
        });
    }
  }

  reconfigureStaffListing();

  //below tracks window resize and will show or hide the expertise on resize.

  $(window).on('resize', function () {
    let myWidth = window.innerWidth;

    if (($('li').hasClass('staff-listing__tag-item--expertise') && myWidth <= 600)) {

      $('.staff-listing__tag-item--expertise').addClass('staff-listing__tag-item--hidden');
    }

    if (($('li').hasClass('staff-listing__tag-item--expertise') && myWidth >= 601)) {
      $('.staff-listing__tag-item--expertise').removeClass('staff-listing__tag-item--hidden');
    }

    if (($('li').hasClass('staff-listing__tag-item--research') && window.innerWidth <= 600)) {
      $('.staff-listing__tag-item--research').addClass('staff-listing__tag-item--hidden');
    }

    if (($('li').hasClass('staff-listing__tag-item--research') && window.innerWidth >= 600)) {
      $('.staff-listing__tag-item--research').removeClass('staff-listing__tag-item--hidden');
    }

  });

}(jQuery));